// Token-overlap fuzzy match between what was typed and the MSA wording
// ("Safety Attendant" vs "Safety Tech"). Suggestion only — never a silent
// fill; the user clicks to apply. Shared by Requests and Estimating.
export const msaTokens = (s) => String(s || '').toLowerCase().split(/[^a-z0-9]+/).filter(t => t.length > 2);
export const msaFuzzyMatch = (text, lines) => {
  const t = msaTokens(text);
  if (!t.length) return null;
  let best = null, bestScore = 0;
  for (const l of lines) {
    const lt = new Set([...msaTokens(l.msa_description), ...msaTokens(l.craft)]);
    const hits = t.filter(x => lt.has(x)).length;
    const score = hits / t.length;
    if (score > bestScore) { bestScore = score; best = l; }
  }
  return bestScore >= 0.5 ? best : null;
};
